import {commonMutationTypes} from "../../../../../../utils/commonQueryTypes";

export interface ResetEmpPasswordResult {
  ResetEmpPassword: boolean;
}

export interface ResetEmpPasswordVar extends commonMutationTypes {
  empID: number;
  customerID: number;
  password: string;
}

export enum SwConfigStrValueType {
  EMP_DEFAULT_PASSWORD = "EMP_DEFAULT_PASSWORD",
  MAX_CALIBRATION_COUNT_FOR_ALCOMETER = "MAX_CALIBRATION_COUNT_FOR_ALCOMETER",
}

export enum SwConfigBannerType {
  BANNER = "BANNER",
}
